import * as React from "react";
import { Component } from "react";

import { Nullable } from "types";
import { getClasses } from "utils";

interface PropsType {
  content: string | JSX.Element;
  heading?: string;
}

interface StateType {
  visible: boolean;
}

export default class ToolTip extends Component<PropsType, StateType> {
  mounted = true;

  state = { visible: false };

  trigger: HTMLButtonElement;

  componentDidMount(): void {
    document.addEventListener("click", this.onDocumentClick);
    document.addEventListener("keydown", this.onDocumentKeyDown);
  }

  componentWillUnmount(): void {
    this.mounted = false;
  }

  close = (): void => {
    if (!this.mounted || !this.state.visible) return;
    this.setState({ visible: false });
  };

  onDocumentClick = (event): void => {
    if (this.mounted && !this.trigger.contains(event.target)) {
      this.close();
    }
  };

  onDocumentKeyDown = (event): void => {
    if (event.which === 27) this.close();
  };

  toggle = (): void => {
    this.setState(({ visible }) => ({ visible: !visible }));
  };

  Heading = (): Nullable<JSX.Element> => {
    const { heading } = this.props;
    return heading ? <h3>{heading}</h3> : null;
  };

  render(): JSX.Element {
    const { Heading } = this;
    const { content, heading } = this.props;
    const { visible } = this.state;

    return (
      <div className="tooltip">
        <button
          onClick={this.toggle}
          ref={(el): void => {
            this.trigger = el;
          }}
          type="button"
        >
          <i className="fas fa-question" />
        </button>

        <div
          className={getClasses("dialog", {
            visible,
            "with-heading": !!heading,
          })}
        >
          <div className="content">
            <Heading />
            <div className="body">{content}</div>
          </div>
        </div>
      </div>
    );
  }
}
